document.addEventListener("DOMContentLoaded", function () {  
(function() {

  /* ===== 1. TRUST BADGES (Product Pages Only) ===== */
  var productForm = document.querySelector('product-form, .product-form, form[action*="/cart/add"]');
  if (productForm) {
    var badgesHTML = '<div class="om-trust-badges">' +
      '<div class="om-trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12l5 5L20 7"/><rect x="1" y="1" width="22" height="22" rx="3"/></svg>Free Shipping $75+</div>' +
      '<div class="om-trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>1-Year Warranty</div>' +
      '<div class="om-trust-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M23 12c0 1-1.3 2-1.8 2.8s-.2 2.3-1 3-2.2.6-3 1-1.8 1.8-2.8 1.8-2-.8-2.8-1.3-2.3-.2-3-1-.6-2.2-1-3S6 13 6 12s.8-2 1.3-2.8.2-2.3 1-3 2.2-.6 3-1S13.1 3.5 14 3.5s2 .8 2.8 1.3 2.3.2 3 1 .6 2.2 1 3 1.7 1.7 1.7 2.7z" transform="translate(-3,-1.5) scale(0.9)"/><path d="M9 12l2 2 4-4"/></svg>30-Day Returns</div>' +
    '</div>';
    productForm.insertAdjacentHTML('afterend', badgesHTML);
  }

  /* ===== 2. STICKY ADD TO CART BAR (Product Pages Only) ===== */

  if (productForm) {
    var title = document.querySelector('.product_name, h1.product__title, .product-title, h1')?.textContent?.trim() || '';
    var price = document.querySelector('.current_price, .product__price, .price .money, .price-item--regular')?.textContent?.trim() || '';
    var img = document.querySelector('.product-gallery img, .product__media img, .product-image img')?.src || '';
    var addBtn = document.querySelector('[type="submit"], .add-to-cart, button[name="add"] , [data-js-product-add-to-cart]');
    console.log(addBtn,'addBtn not displayed')
    if (title && addBtn) {
      var stickyHTML = '<div class="om-sticky-atc" id="om-sticky-bar">' +
        (img ? '<img class="om-sticky-atc__img" src="' + img + '" alt="">' : '') +
        '<div class="om-sticky-atc__info"><span class="om-sticky-atc__title">' + title + '</span>' +
        '<span class="om-sticky-atc__price">' + price + '</span></div>' +
        '<button class="om-sticky-atc__btn" id="om-sticky-btn">Add to Cart</button></div>';
      document.body.insertAdjacentHTML('beforeend', stickyHTML);

      document.getElementById('om-sticky-btn').addEventListener('click', function() {
        addBtn.click();
      });

      var observer = new IntersectionObserver(function(entries) {
        var bar = document.getElementById('om-sticky-bar');
        if (!bar) return;
        entries.forEach(function(e) {
          if (e.isIntersecting) { bar.classList.remove('om-visible'); }
          else { bar.classList.add('om-visible'); }
        });
      }, {threshold: 0});
      observer.observe(addBtn);
    }
  }

  /* ===== 4. CROSS-SELL (Product Pages Only) ===== */
  if (productForm && window.location.pathname.includes('/products/')) {
    var crossSellDiv = document.createElement('div');
    crossSellDiv.className = 'om-cross-sell';
    crossSellDiv.innerHTML = '<h3>Complete Your Kit</h3><div class="om-cross-sell__grid" id="om-cross-grid"></div>';
    
    var productDesc = document.querySelector('product-description');
    if (productDesc) {
      productDesc.parentNode.insertBefore(crossSellDiv, productDesc.nextSibling);
    } else {
      productForm.parentNode.appendChild(crossSellDiv);
    }

    fetch('/collections/all/products.json?limit=8')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var currentPath = window.location.pathname;
        var products = data.products.filter(function(p) { return '/products/' + p.handle !== currentPath; }).slice(0, 4);
        var grid = document.getElementById('om-cross-grid');
        if (!grid) return;
        products.forEach(function(p) {
          var imgSrc = p.images[0] ? p.images[0].src.replace(/\.([a-z]+)$/, '_200x200.$1') : '';
          var priceStr = (parseFloat(p.variants[0].price) || 0).toLocaleString('en-US', {style:'currency',currency:'USD'});
          grid.innerHTML += '<a class="om-cross-sell__item" href="/products/' + p.handle + '">' +
            '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g,'') + '" loading="lazy">' +
            '<div class="om-cross-sell__item-title">' + p.title + '</div>' +
            '<div class="om-cross-sell__item-price">' + priceStr + '</div></a>';
        });
      }).catch(function(){});
  }
  
})();
});